export default "__VITE_ASSET__COslpJ4G__"